import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';

export const PullLeft = styled.div`
    ${fromLarge`
        margin-left: -130px;
    `}
`;
